module.exports = __webpack_public_path__ + "static/10-786c86be35032960ef2cfceb8eda8a73.png";